import { PortfolioPosition } from 'portfolio/PortfolioSelection';
import { SymbologyValues } from 'app/store/appSettings/AppSettingsState';

export type OrderIdsSource = 'UpdateParms' | 'EmbeddedApi';

export interface EmbeddedAppPositionsState {
    values?: PortfolioPosition[];
    /*
     * The symbology that the symbols in the positions are for. Defaults to Instinet
     */
    symbology?: SymbologyValues;
}

export interface EmbeddedAppState {
    /*
     ** The order ids received in the stream from Newport in the _o parameter, or from the embedded API SetOrderIdsMessage
     */
    orderIds?: string[];
    /*
     * Whether we received these orders ids from the Newport UpdateParms stream or via the Embedded API
     */
    orderIdsSource?: OrderIdsSource;
    /*
     * The positions received in a "port" parameter of format <sym1>|<sym2>|<sym3>, or from the embedded API SetPositionsMessage
     */
    positions?: EmbeddedAppPositionsState;
    alerts: string[];
    /*
     * Stylesheet set by the host to be linked to
     */
    stylesheetUrl?: string;
    /*
     * If the host sets a border via stylesheetUrl, this is how large it is
     */
    hostBorderPx?: number;
    /*
     * Max/Min/Close buttons will be added to the application toolbar in an embedded dashboard unless this is set
     */
    hideWindowButtons?: boolean;
}

export const initialEmbeddedAppState: EmbeddedAppState = { alerts: [] };
